var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-xl": "" } },
    [
      _c(
        "v-flex",
        { attrs: { xs12: "", md8: "", "offset-md2": "", "margin-auto": "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "", "text-xs-center": "", "mb-4": "" } },
            [
              _c("div", [
                _c(
                  "div",
                  { staticClass: "left" },
                  [
                    _c("v-select", {
                      attrs: {
                        value: "My Quotes",
                        items: ["My Quotes", "All"]
                      },
                      on: { change: _vm.getRecordsOf }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "right" },
                  [
                    _c(
                      "v-btn",
                      {
                        staticStyle: {
                          padding: "30px 60px",
                          "font-size": "20px"
                        },
                        attrs: { to: "/quotes/new", color: "success" }
                      },
                      [_vm._v("New Quote "), _c("v-icon", [_vm._v("add")])],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { clear: "both" } },
                [
                  _c("v-text-field", {
                    staticStyle: { width: "50%", margin: "0 auto" },
                    attrs: {
                      "append-icon": "search",
                      label: "Search",
                      "single-line": "",
                      "hide-details": ""
                    },
                    on: {
                      change: function($event) {
                        return _vm.searchQuotes()
                      }
                    },
                    model: {
                      value: _vm.search,
                      callback: function($$v) {
                        _vm.search = $$v
                      },
                      expression: "search"
                    }
                  })
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c("v-flex", { attrs: { w4: "", "text-xs-center": "" } }, [
            _c("h1", { staticClass: "mb-3 pinkk" }, [_vm._v("Open Quotes")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "circle pinkkBorder",
                class: _vm.openClick === true ? "circleActive" : "pinkk",
                on: {
                  click: function($event) {
                    ;(_vm.archivedClick = false),
                      (_vm.openClick = true),
                      (_vm.ageingClick = false),
                      _vm.searchQuotes()
                  }
                }
              },
              [
                _vm.quoteLoading
                  ? _c(
                      "div",
                      { attrs: { "justify-center": "", "align-center": "" } },
                      [
                        _c("v-progress-circular", {
                          attrs: { indeterminate: "", color: "primary" }
                        })
                      ],
                      1
                    )
                  : _c("div", {}, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.openQuotesCount) +
                          "\n        "
                      )
                    ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("v-flex", { attrs: { w4: "", "text-xs-center": "" } }, [
            _c("h1", { staticClass: "mb-3 greyy" }, [_vm._v("Ageing Quotes")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "circle",
                class: _vm.ageingClick === true ? "circleActive" : "greyy",
                on: {
                  click: function($event) {
                    ;(_vm.archivedClick = false),
                      (_vm.openClick = false),
                      (_vm.ageingClick = true),
                      _vm.searchQuotes()
                  }
                }
              },
              [
                _vm.quoteLoading
                  ? _c(
                      "div",
                      { attrs: { "justify-center": "", "align-center": "" } },
                      [
                        _c("v-progress-circular", {
                          attrs: { indeterminate: "", color: "primary" }
                        })
                      ],
                      1
                    )
                  : _c("div", {}, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.ageingQuotesCount) +
                          "\n        "
                      )
                    ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("v-flex", { attrs: { w4: "", "text-xs-center": "" } }, [
            _c("h1", { staticClass: "mb-3 greyy" }, [
              _vm._v("Archived Quotes")
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "circle",
                class: _vm.archivedClick === true ? "circleActive" : "greyy",
                on: {
                  click: function($event) {
                    ;(_vm.archivedClick = true),
                      (_vm.openClick = false),
                      (_vm.ageingClick = false),
                      _vm.searchQuotes()
                  }
                }
              },
              [
                _vm.quoteLoading
                  ? _c(
                      "div",
                      { attrs: { "justify-center": "", "align-center": "" } },
                      [
                        _c("v-progress-circular", {
                          attrs: { indeterminate: "", color: "primary" }
                        })
                      ],
                      1
                    )
                  : _c("div", {}, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.archivedQuotesCount) +
                          "\n        "
                      )
                    ])
              ]
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "mb-5", staticStyle: { clear: "both" } }),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { xs12: "", md8: "", "offset-md2": "", "margin-auto": "" } },
        [
          _c(
            "v-card",
            [
              _vm.cmReceivedQuotes.length && _vm.archivedClick === false
                ? _c(
                    "div",
                    { staticClass: "borderPink" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "cmReceived",
                          on: {
                            click: function($event) {
                              _vm.showCMReceived = !_vm.showCMReceived
                            }
                          }
                        },
                        [_vm._v("CM Received")]
                      ),
                      _vm._v(" "),
                      _vm.showCMReceived && _vm.cmReceivedQuotes.length
                        ? _c(
                            "v-data-table",
                            {
                              attrs: {
                                headers: _vm.headers,
                                items: _vm.cmReceivedQuotes,
                                loading: _vm.quoteLoading,
                                pagination: _vm.pagination,
                                "total-items": _vm.totalQuotes,
                                "rows-per-page-items": _vm.rowsPerPageItems
                              },
                              on: {
                                "update:pagination": function($event) {
                                  _vm.pagination = $event
                                }
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "items",
                                    fn: function(props) {
                                      return [
                                        _vm.editDeleteAllowed
                                          ? _c(
                                              "td",
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      small: "",
                                                      flat: "",
                                                      color: "primary",
                                                      target: "_blank",
                                                      to:
                                                        "/quotes/edit/" +
                                                        props.item._id
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        props.item.orderCode
                                                      )
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          : _c("td", [
                                              _vm._v(
                                                _vm._s(props.item.orderCode)
                                              )
                                            ]),
                                        _vm._v(" "),
                                        props.item.customerID
                                          ? _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  props.item.customerID
                                                    .firstName
                                                ) +
                                                  " " +
                                                  _vm._s(
                                                    props.item.customerID
                                                      .lastName
                                                  )
                                              )
                                            ])
                                          : _c("td", [_vm._v("N/A")]),
                                        _vm._v(" "),
                                        props.item.updatedBy
                                          ? _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  props.item.updatedBy.firstName
                                                )
                                              )
                                            ])
                                          : props.item.createdBy
                                          ? _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  props.item.createdBy.firstName
                                                )
                                              )
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            "$" +
                                              _vm._s(
                                                props.item.subTotal.toFixed(2)
                                              )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              new Date(
                                                props.item.date
                                              ).getDate() +
                                                "/" +
                                                (new Date(
                                                  props.item.date
                                                ).getMonth() +
                                                  1) +
                                                "/" +
                                                new Date(
                                                  props.item.date
                                                ).getFullYear()
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          [
                                            _c("v-select", {
                                              attrs: {
                                                items: _vm.actionItems(props),
                                                label: "Actions"
                                              },
                                              on: { change: _vm.quoteActions }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2008194487
                              )
                            },
                            [
                              _c("v-progress-linear", {
                                attrs: {
                                  slot: "progress",
                                  color: "primary",
                                  indeterminate: ""
                                },
                                slot: "progress"
                              }),
                              _vm._v(" "),
                              _vm._v(" "),
                              _c("template", { slot: "no-data" }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.loadingText) +
                                    "\n          "
                                )
                              ]),
                              _vm._v(" "),
                              _c("template", { slot: "no-results" }, [
                                _vm._v(
                                  "\n            Your search for '" +
                                    _vm._s(_vm.search) +
                                    "' didn't return any results.\n          "
                                )
                              ])
                            ],
                            2
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-data-table",
                {
                  attrs: {
                    headers: _vm.headers,
                    items: _vm.quotes,
                    loading: _vm.quoteLoading,
                    pagination: _vm.pagination,
                    "total-items": _vm.totalQuotes,
                    "rows-per-page-items": _vm.rowsPerPageItems
                  },
                  on: {
                    "update:pagination": function($event) {
                      _vm.pagination = $event
                    }
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "items",
                      fn: function(props) {
                        return [
                          _vm.editDeleteAllowed
                            ? _c(
                                "td",
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        small: "",
                                        flat: "",
                                        color: "primary",
                                        target: "_blank",
                                        to: "/quotes/edit/" + props.item._id
                                      }
                                    },
                                    [_vm._v(_vm._s(props.item.orderCode))]
                                  )
                                ],
                                1
                              )
                            : _c("td", [_vm._v(_vm._s(props.item.orderCode))]),
                          _vm._v(" "),
                          props.item.customerID
                            ? _c("td", [
                                _vm._v(
                                  _vm._s(props.item.customerID.firstName) +
                                    " " +
                                    _vm._s(props.item.customerID.lastName)
                                )
                              ])
                            : _c("td", [_vm._v("N/A")]),
                          _vm._v(" "),
                          props.item.updatedBy
                            ? _c("td", [
                                _vm._v(_vm._s(props.item.updatedBy.firstName))
                              ])
                            : props.item.createdBy
                            ? _c("td", [
                                _vm._v(_vm._s(props.item.createdBy.firstName))
                              ])
                            : _c("td"),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v("$" + _vm._s(props.item.subTotal.toFixed(2)))
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                new Date(props.item.date).getDate() +
                                  "/" +
                                  (new Date(props.item.date).getMonth() + 1) +
                                  "/" +
                                  new Date(props.item.date).getFullYear()
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.actionItems(props),
                                  label: "Actions"
                                },
                                on: { change: _vm.quoteActions }
                              })
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ])
                },
                [
                  _c("v-progress-linear", {
                    attrs: {
                      slot: "progress",
                      color: "primary",
                      indeterminate: ""
                    },
                    slot: "progress"
                  }),
                  _vm._v(" "),
                  _vm._v(" "),
                  _c("template", { slot: "no-data" }, [
                    _vm._v(
                      "\n          " + _vm._s(_vm.loadingText) + "\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _c("template", { slot: "no-results" }, [
                    _vm._v(
                      "\n          Your search for '" +
                        _vm._s(_vm.search) +
                        "' didn't return any results.\n        "
                    )
                  ])
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-center" },
        [
          _c(
            "v-dialog",
            {
              attrs: { width: "500" },
              model: {
                value: _vm.dialog,
                callback: function($$v) {
                  _vm.dialog = $$v
                },
                expression: "dialog"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    {
                      staticClass: "headline grey lighten-2",
                      attrs: { "primary-title": "" }
                    },
                    [_vm._v("\n          Download CM\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    _vm._l(_vm.CMs, function(CM, index) {
                      return _c(
                        "div",
                        { key: "bb" + index, staticClass: "level" },
                        [
                          _c(
                            "v-container",
                            { attrs: { fluid: "", "grid-list-xl": "" } },
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "", sm6: "" } },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "level-item",
                                          on: {
                                            click: function($event) {
                                              return _vm.downloadCheckMeasure(
                                                CM.file
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v(_vm._s(CM.file))]
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary", text: "" },
                          on: {
                            click: function($event) {
                              _vm.dialog = false
                            }
                          }
                        },
                        [_vm._v("\n            Close\n          ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.selectedIndex !== null
        ? _c(
            "v-dialog",
            {
              attrs: { "max-width": "600px" },
              model: {
                value: _vm.paymentDialog,
                callback: function($$v) {
                  _vm.paymentDialog = $$v
                },
                expression: "paymentDialog"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", [_c("h4", [_vm._v("Payment")])]),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    [
                      _c("v-select", {
                        attrs: {
                          label: "Payment Status",
                          items: ["Full Payment", "Deposit Paid"]
                        },
                        model: {
                          value: _vm.quotes[_vm.selectedIndex].paymentStatus,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.quotes[_vm.selectedIndex],
                              "paymentStatus",
                              $$v
                            )
                          },
                          expression: "quotes[selectedIndex].paymentStatus"
                        }
                      }),
                      _vm._v(" "),
                      _vm.quotes[_vm.selectedIndex].paymentStatus ===
                      "Deposit Paid"
                        ? _c("v-text-field", {
                            attrs: { label: "Deposit Amount" },
                            model: {
                              value: _vm.quotes[_vm.selectedIndex].paidAmount,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.quotes[_vm.selectedIndex],
                                  "paidAmount",
                                  $$v
                                )
                              },
                              expression: "quotes[selectedIndex].paidAmount"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.quotes[_vm.selectedIndex].install > 0
                    ? _c(
                        "v-card-text",
                        [
                          _c("v-label", [_vm._v("Check Measure Required?")]),
                          _vm._v(" "),
                          _c(
                            "v-radio-group",
                            {
                              attrs: { row: "" },
                              on: { click: _vm.changecmFormLink },
                              model: {
                                value: _vm.quotes[_vm.selectedIndex].cmRequired,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.quotes[_vm.selectedIndex],
                                    "cmRequired",
                                    $$v
                                  )
                                },
                                expression: "quotes[selectedIndex].cmRequired"
                              }
                            },
                            [
                              _c("v-radio", {
                                attrs: {
                                  label: "Yes",
                                  color: "primary",
                                  value: "yes"
                                }
                              }),
                              _vm._v(" "),
                              _c("v-radio", {
                                attrs: {
                                  label: "No",
                                  color: "primary",
                                  value: "no"
                                }
                              }),
                              _vm._v(" "),
                              _c("v-radio", {
                                attrs: {
                                  label: "Completed",
                                  color: "primary",
                                  value: "completed"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.cmFormLink != "" &&
                          (_vm.quotes[_vm.selectedIndex].cmRequired === "yes" ||
                            _vm.quotes[_vm.selectedIndex].cmRequired ===
                              "completed")
                            ? _c(
                                "div",
                                [
                                  _c("v-card-title", [
                                    _vm.quotes[_vm.selectedIndex].cmRequired ===
                                    "yes"
                                      ? _c("h2", [
                                          _vm._v(
                                            _vm._s(_vm.shippingState) +
                                              " CM Request Form"
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.quotes[_vm.selectedIndex].cmRequired ===
                                    "completed"
                                      ? _c("h2", [
                                          _vm._v(
                                            _vm._s(_vm.shippingState) +
                                              " Install Request Form"
                                          )
                                        ])
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _c("v-divider"),
                                  _vm._v(" "),
                                  _c("v-card-text", {
                                    domProps: {
                                      innerHTML: _vm._s(_vm.cmFormLink)
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "success" },
                          on: {
                            click: function($event) {
                              return _vm.updatePayment()
                            }
                          }
                        },
                        [_vm._v("Submit")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary" },
                          on: {
                            click: function($event) {
                              _vm.paymentDialog = false
                            }
                          }
                        },
                        [_vm._v("Close")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedIndex !== null
        ? _c(
            "v-dialog",
            {
              attrs: { "max-width": "600px" },
              model: {
                value: _vm.cmRequiredDialog,
                callback: function($$v) {
                  _vm.cmRequiredDialog = $$v
                },
                expression: "cmRequiredDialog"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", [_c("h2", [_vm._v("Are you sure?")])]),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-flex",
                        {
                          attrs: {
                            xs12: "",
                            sm12: "",
                            "mb-3": "",
                            "cursor-pointer": ""
                          },
                          on: {
                            click: function($event) {
                              _vm.showNotes = !_vm.showNotes
                            }
                          }
                        },
                        [
                          _c("h1", [
                            _vm._v(
                              "Notes (" +
                                _vm._s(
                                  _vm.quotes[_vm.selectedIndex]
                                    .installationNotes.length
                                ) +
                                ")"
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _vm.showNotes
                        ? _c(
                            "div",
                            _vm._l(
                              _vm.quotes[_vm.selectedIndex].installationNotes,
                              function(note, index) {
                                return _c(
                                  "div",
                                  { key: "aa" + index, staticClass: "level" },
                                  [
                                    _c(
                                      "v-layout",
                                      { attrs: { row: "", wrap: "" } },
                                      [
                                        _c(
                                          "v-flex",
                                          {
                                            attrs: {
                                              xs12: "",
                                              sm12: "",
                                              "mb-3": ""
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "note-date" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getNoteDate(note.date)
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "note-name-time" },
                                              [
                                                _vm._v(
                                                  _vm._s(note.username) +
                                                    " - " +
                                                    _vm._s(
                                                      _vm.getNoteTime(note.date)
                                                    )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "note-note" },
                                              [_vm._v(_vm._s(note.note))]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              }
                            ),
                            0
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("v-textarea", {
                        attrs: { label: "Installation Notes" },
                        model: {
                          value: _vm.installationNote,
                          callback: function($$v) {
                            _vm.installationNote = $$v
                          },
                          expression: "installationNote"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm12: "", "text-sm-right": "" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "success" },
                              on: {
                                click: function($event) {
                                  return _vm.addNote()
                                }
                              }
                            },
                            [_vm._v("Add Note")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "success" },
                          on: {
                            click: function($event) {
                              return _vm.updateInstallationStatus()
                            }
                          }
                        },
                        [_vm._v("Submit")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary" },
                          on: {
                            click: function($event) {
                              _vm.cmRequiredDialog = false
                            }
                          }
                        },
                        [_vm._v("Close")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-snackbar",
        {
          attrs: { dark: "", top: "", timeout: 3000 },
          model: {
            value: _vm.snackbar,
            callback: function($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar"
          }
        },
        [
          _vm._v("\n    " + _vm._s(_vm.popupText) + "\n    "),
          _c(
            "v-btn",
            {
              attrs: { dark: "", flat: "" },
              on: {
                click: function($event) {
                  _vm.snackbar = false
                }
              }
            },
            [_vm._v("Close")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f981dcf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f981dcf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/quotes/Quotes.vue
// module id = null
// module chunks = 